import { z } from 'zod';

export const FinishCostItemSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  default_cost_per_sqft: z.coerce.number().default(0),
  notes: z.string().nullable(),
  active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateFinishCostItemSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  default_cost_per_sqft: z.coerce.number().min(0).default(0),
  notes: z.string().nullable().optional(),
  active: z.boolean().default(true),
});

export const UpdateFinishCostItemSchema = CreateFinishCostItemSchema.partial();

/** A cost item as attached to one finish profile. */
export const FinishCostItemLinkSchema = z.object({
  id: z.string().uuid(),
  finish_id: z.string().uuid(),
  finish_cost_item_id: z.string().uuid(),
  /** null = inherit cost_item.default_cost_per_sqft */
  cost_per_sqft_override: z.coerce.number().nullable(),
  sort_order: z.number().int().default(0),
  cost_item: FinishCostItemSchema.optional(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateFinishCostItemLinkSchema = z.object({
  finish_cost_item_id: z.string().uuid(),
  cost_per_sqft_override: z.coerce.number().min(0).nullable().optional(),
  sort_order: z.number().int().default(0),
});

export type FinishCostItem = z.infer<typeof FinishCostItemSchema>;
export type CreateFinishCostItem = z.infer<typeof CreateFinishCostItemSchema>;
export type UpdateFinishCostItem = z.infer<typeof UpdateFinishCostItemSchema>;
export type FinishCostItemLink = z.infer<typeof FinishCostItemLinkSchema>;
export type CreateFinishCostItemLink = z.infer<typeof CreateFinishCostItemLinkSchema>;
